import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'hash',
	routes: [
		{
			path: '/',
			name: 'Index',
			component: require('@/components/Index').default
		},
		{
			path: '/About',
			name: 'About',
			component: require('@/components/About').default

		},
		{
			path: '/videoList',
			name: 'VideoList',
			component: require('@/components/VideoList').default,
		},
		{
			path: '/newsList',
			name: 'NewsList',

			component: require('@/components/NewsList').default,
		}
		,
		{
			path: '/news',
			name: 'News',

			component: require('@/components/News').default,
		}
		,
		{
			path: '/com',
			name: 'Com',

			component: require('@/components/Com').default,
		}
		,
		{
			path: '/comList',
			name: 'ComList',

			component: require('@/components/ComList').default,
		},
		{
			path: '/fashionList',
			name: 'FashionList',
			component: require('@/components/FashionList').default,
		},
		{
			path: '/fashion',
			name: 'Fashion',
			component: require('@/components/Fashion').default,
		},
		{
			path: '/zxkc',
			name: 'zxkc',
			component: require('@/components/zxkc').default,
		},
		{
			path: '/xnfz',
			name: 'xnfz',
			component: require('@/components/xnfz').default,
		},
		{
			path: '/kycg',
			name: 'kycg',
			component: require('@/components/kycg').default,
		},
		{
			path: '/szll',
			name: 'szll',
			component: require('@/components/szll').default,
		},
		{
			path: '/yjhj',
			name: 'yjhj',
			component: require('@/components/yjhj').default,
		},
		{
			path: '/xszp',
			name: 'xszp',
			component: require('@/components/xszp').default,
		},
		{
			path: '/hzjl',
			name: 'hzjl',
			component: require('@/components/hzjl').default,
		},
		{
			path: '/qywx',
			name: 'qywx',
			component: require('@/components/qywx').default,
		},
		{
			path: '/ViewPpt',
			name: 'ViewPpt',
			component: require('@/components/ViewPpt').default,
		},
		{
			path: '/ViewMp4',
			name: 'ViewMp4',
			component: require('@/components/ViewMp4').default,
		},
		{
			path: '/resourceLib',
			name: 'resourceLib',
			component: require('@/components/resourceLib').default,
		},

	]
})
